import React, { useState, useEffect, useRef } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Conexao from '../../../../providers/Conexao';
import DisplayStatusEquipamento from './DisplayStatusEquipamento';
import TagStatusEquipamento from './TagStatusEquipamento';
import TonerLevel from '../../../../Componentes/TonerLevel';
import { Message } from 'primereact/message';
import { Messages } from 'primereact/messages';
import NivelGeral from '../../../../Componentes/NivelGeral';
import ModalGraficoConsumo from './ModalGraficoConsumo';
import { InputTextarea } from 'primereact/inputtextarea';
import { Slider } from "primereact/slider";
import { Tag } from 'primereact/tag';
import { SelectButton } from 'primereact/selectbutton';
import ModalSliderNiveisToner from './ModalSliderNiveisToner';
import { Checkbox } from "primereact/checkbox";



export default function SidebarDetalheColetas(props) {
    const { verInativos, setVerInativos, verDesconectados, setVerDesconectados, verDescobertas, setVerDescobertas } = props;
    const options = ['Desligado', 'Global', 'Individual'];
    const [open, setOpen] = useState(false)
    const [detalhes, setDetalhes] = useState([])
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [serialAlternativo, setSerialAlternativo]= useState('')
    const [pat, setPat]= useState('')
    const [setor, setSetor]= useState('')
    const [openPrevisao, setOpenPrevisao] = useState({
        open : false, 
        cor: '', 
        numeroserie : ''
    })
    const [tipoMonitoramento, setTipoMonitoramento] = useState('Desligado')
    const [nivelAlertaIndividual, setNivelAlertaIndividual] = useState({
            open : false, 
            coleta : []
         })

    const handleChange = (value) => {
    //setValue(e.value);
    
    switch (value) {
        case 'Desligado':            
            props.showMessageToast('warn', 'Não é possivel desabilitar individualmente!')
            break;

        case 'Global':
            confirmDialog({
                message: 'Deseja voltar ao monitoramento Global?',
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sim',
                rejectLabel: 'Não',
                accept: () => {
                     Conexao.post('coletasController/habilitarMonitoramentoSuprimentos', {
                            idColeta : props.coleta.idcoleta,
                            idEmpresa : props.coleta.idempresa,
                            idCliente : props.coleta.idcliente,
                            alertaCiano	: 'f',
                            alertaMagenta	: 'f',
                            alertaAmarelo	: 'f',
                            alertaPreto	: 'f',
                            nivelCiano :  0,
                            nivelMagenta :  0,
                            nivelAmarelo : 0,
                            nivelPreto : 0,
                        }).then(response=>{
                            if(response.status === 200 && response.data.status ==='OK'){
                                props.setColetasNiveis(props.coleta.idcoleta,{
                                    alertaciano : 'f', 
                                    nivelalertaciano : 0, 
                                    alertamagenta : 'f', 
                                    nivelalertamagenta :0, 
                                    alertaamarelo : 'f',  
                                    nivelalertaamarelo : 0, 
                                    alertapreto : 'f', 
                                    nivelalertapreto : 0, 
                                })
                            setTipoMonitoramento(value)
                            }
                        }).catch(error=>{

                        })
                }
            });
            break;

        case 'Individual':
             confirmDialog({
                message: 'Deseja Ativar/Gerenciar o monitoramento individual para este equipamento?',
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sim',
                rejectLabel: 'Não',
                accept: () => {
                    setNivelAlertaIndividual({
                        open : true, 
                        coleta : props.coleta
                    })
                    //setTipoMonitoramento(value)
                }
            });
            break;

        default:
            break;
    }
};
    useEffect(() => {
                // Função que será chamada quando o tamanho da janela mudar
                const handleResize = () => {
                    setWindowWidth(window.innerWidth);
                };
        
                // Adiciona o listener de resize
                window.addEventListener('resize', handleResize);
        
                // Limpeza do evento quando o componente for desmontado
                return () => {
                    window.removeEventListener('resize', handleResize);
                };
            }, []);

    const buscarDados = useRef(false)
    const [contadores, setContadores] = useState([])

    React.useEffect(() => {
        if (!detalhes.idcoleta){
            setContadores([])
            return;
        } 
    
        setPat(detalhes.placa)
        setSetor(props.coleta.setor ? props.coleta.setor : props.coleta.syslocation)
        setSerialAlternativo(props.coleta.setor ? props.coleta.setor : props.coleta.syslocation)
        const novosContadores = [];
    
        if (detalhes.contadortotalgeral) {
            novosContadores.push({
                title: true,
                padding : '0px',
                name: 'Contador Total Geral',
                value: detalhes.contadortotalgeral
            });
        }

        /*contadores térmicas */
        if (detalhes.contadorcentimetros) {
            novosContadores.push({
                title: true,
                padding : '0px',
                name: 'Contador Centimetros',
                value: detalhes.contadorcentimetros
            });
        }
        if (detalhes.contadorpolegadas) {
            novosContadores.push({
                title: true,
                padding : '0px',
                name: 'Contador Polegadas',
                value: detalhes.contadorpolegadas
            });
        }

        if (detalhes.contadormetros) {
            novosContadores.push({
                title: true,
                padding : '0px',
                name: 'Contador Metros',
                value: detalhes.contadormetros
            });
        }



    
        /* contadores monocromáticos */
        if (detalhes.contadormonototal) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Contador Mono Total',
                value: detalhes.contadormonototal
            });
        }

        if (detalhes.contadormonoa4) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono A4',
                value: detalhes.contadormonoa4
            });
        }

        if (detalhes.contadormonoa3) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono A3',
                value: detalhes.contadormonoa3
            });
        }

        if (detalhes.contadormonoa5) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono A5',
                value: detalhes.contadormonoa5
            });
        }

        if (detalhes.contadormonoa6) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono A6',
                value: detalhes.contadormonoa6
            });
        }

        if (detalhes.contadormonolether) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono Lether',
                value: detalhes.contadormonolether
            });
        }

        if (detalhes.contadormonooficio) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono Oficio',
                value: detalhes.contadormonooficio
            });
        }

        if (detalhes.contadormonob5) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono B5',
                value: detalhes.contadormonob5
            });
        }

        if (detalhes.contadormonoexecutivo) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono Executivo',
                value: detalhes.contadormonoexecutivo
            });
        }

        if (detalhes.contadormonoexecutivo) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono Executivo',
                value: detalhes.contadormonoexecutivo
            });
        }

        if (detalhes.contadormonocopia) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Copia Mono',
                value: detalhes.contadormonocopia
            });
        }

        if (detalhes.contadormonoprinter) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Printer Mono',
                value: detalhes.contadormonoprinter
            });
        }

        if (detalhes.contadormonofax) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Fax Mono',
                value: detalhes.contadormonofax
            });
        }

        if (detalhes.contadormonooutros) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Outros Mono',
                value: detalhes.contadormonooutros
            });
        }
        

        /* contadores coloridos */
        if (detalhes.contadorcolortotal) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Contador Color Total',
                value: detalhes.contadorcolortotal
            });
        }

        if (detalhes.contadorcolora4) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color A4',
                value: detalhes.contadorcolora4
            });
        }

        if (detalhes.contadorcolora3) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color A3',
                value: detalhes.contadorcolora3
            });
        }

        if (detalhes.contadorcolora5) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color A5',
                value: detalhes.contadorcolora5
            });
        }

        if (detalhes.contadorcolora6) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color A6',
                value: detalhes.contadorcolora6
            });
        }

        if (detalhes.contadorcolorlether) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color Lether',
                value: detalhes.contadorcolorlether
            });
        }

        if (detalhes.contadorcoloroficio) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color Oficio',
                value: detalhes.contadorcoloroficio
            });
        }

        if (detalhes.contadorcolorb5) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color B5',
                value: detalhes.contadorcolorb5
            });
        }

        if (detalhes.contadorcolorexecutivo) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color Executivo',
                value: detalhes.contadorcolorexecutivo
            });
        }

        if (detalhes.contadorcolorexecutivo) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color Executivo',
                value: detalhes.contadorcolorexecutivo
            });
        }

        if (detalhes.contadorcolorcopia) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Copia color',
                value: detalhes.contadorcolorcopia
            });
        }

        if (detalhes.contadorcolorprinter) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Printer Color',
                value: detalhes.contadorcolorprinter
            });
        }

        if (detalhes.contadorcolorfax) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Fax Color',
                value: detalhes.contadorcolorfax
            });
        }

        if (detalhes.contadorcoloroutros) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Outros Color',
                value: detalhes.contadorcoloroutros
            });
        }

        if (detalhes.contadorcopiacorintegral) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Copia Cor Integral',
                value: detalhes.contadorcopiacorintegral
            });
        }

        if (detalhes.contadorcopiacorunica) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Copia Cor Única',
                value: detalhes.contadorcopiacorunica
            });
        }

        if (detalhes.contadorcopiaduascores) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Copia Duas Cores',
                value: detalhes.contadorcopiaduascores
            });
        }

        if (detalhes.contadorprintercorintegral) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Printer Cor Integral',
                value: detalhes.contadorprintercorintegral
            });
        }

        if (detalhes.contadorprintercopiacorunica) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Printer Cor Única',
                value: detalhes.contadorprintercopiacorunica
            });
        }

        if (detalhes.contadorprintercopiaduascores) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Printer Duas Cores',
                value: detalhes.contadorprintercopiaduascores
            });
        }
        if (detalhes.faxcorunica) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Fax Cor Única',
                value: detalhes.faxcorunica
            });
        }

        if (detalhes.a3dlt) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'A3/Duplo Carta',
                value: detalhes.a3dlt
            });
        }
        if (detalhes.duplex) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Duplex',
                value: detalhes.duplex
            });
        }

        if (detalhes.contadorrelatorios) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Relatórios',
                value: detalhes.contadorrelatorios
            });
        }

        if (detalhes.contadorprinttotal) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Contador Printer Total',
                value: detalhes.contadorprinttotal
            });
        }

        if (detalhes.contadorcopiatotal) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Contador Cópia Total',
                value: detalhes.contadorcopiatotal
            });
        }

        if (detalhes.contadorfaxtotal) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Contador Fax Total',
                value: detalhes.contadorfaxtotal
            });
        }

        if (detalhes.ciclosmecanismo) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Ciclos Mecanismo',
                value: detalhes.ciclosmecanismo
            });
        }
        if (detalhes.ciclosmecanismocolor) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Ciclos Mecanismo Color',
                value: detalhes.ciclosmecanismocolor
            });
        }

        /* contadores scanner */
        if (detalhes.contadortotalscanner) {
            novosContadores.push({
                title: true,
                padding : '20px',
                name: 'Contador Total Scanner',
                value: detalhes.contadortotalscanner
            });
        }
        if (detalhes.contadormonoscanner) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Mono Scanner',
                value: detalhes.contadormonoscanner
            });
        }

        if (detalhes.contadorcolorscanner) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Color Scanner',
                value: detalhes.contadorcolorscanner
            });
        }

        if (detalhes.adfimages) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Digitalização ARDF',
                value: detalhes.adfimages
            });
        }

        if (detalhes.flatbedimages) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Contador Digitalização Vidro Exposição',
                value: detalhes.flatbedimages
            });
        }

        if (detalhes.contadorscannercopia) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Digitalizações para cópia',
                value: detalhes.contadorscannercopia
            });
        }

        if (detalhes.contadorscannerfax) {
            novosContadores.push({
                title: false,
                padding : '30px',
                name: 'Digitalizações para FAX',
                value: detalhes.contadorscannerfax
            });
        }

    
        if (novosContadores.length > 0) {
            setContadores((prev) => [...prev, ...novosContadores]);
        }
    
    }, [detalhes]);
    

    const customHeader = (
        <div className="flex align-items-center gap-2"> 
         
            <span className="font-bold text-xl" style={{marginLeft : '10px'}}><Tag severity="contrast" value={props.coleta.numeroserieview}></Tag> {detalhes.modelo}</span>
            {
                detalhes.ativo === 't' ?
                <Tag severity='success' value ='ATIVO'></Tag>
                :
                <Tag severity='danger' value ='INATIVO'></Tag>
            }

            {
                detalhes.equipamentonovo === 'f' ?
                <Tag severity='success' value ='Monitorada'></Tag>
                :
                <Tag severity='danger' value ='Não monitorada'></Tag>
            }

            {
                props.coleta.dias ?
                <Tag severity='success' value ='ONLINE'></Tag>
                :
                <Tag severity='danger' value ='OFFLINE'></Tag>
            }

                        

        </div>
    );

    const getDetalhes = () =>{
        console.log('buscando dados coleta')
        setContadores([])
        Conexao.get('coletasController/getDetalhes?idcoleta='+props.coleta.idcoleta+'&op=previsao').then(response=>{
            if(response.status && response.data.status === 'OK'){
                setDetalhes(response.data.payload)
            }else{
                setDetalhes([])
                props.setColeta([])
            }
        }).catch(error=>{
            setDetalhes([])
            props.setColeta([])
        })
    }

   const updateCadastroEquipamento = () => {
    Conexao.post('coletasController/updateCadastroEquipamento', {
        codigoEmpresa: detalhes.idempresa,
        idcoleta: detalhes.idcoleta,
        patrimonio: detalhes.placa,
        setor: detalhes.setor,
        valorFranquia: detalhes.valorfranquia,
        serialalternativo: detalhes.serialalternativo
    }).then(response => {
        if (response.status && response.data.status === 'OK') {
            if (props.setColetas) {
                props.setColetas({
                    idcoleta : detalhes.idcoleta,
                    setor: detalhes.setor,
                    placa: detalhes.placa,
                    serialalternativo: detalhes.serialalternativo ? detalhes.serialalternativo?.toUpperCase() : props.coleta.numeroserie});
            }
        } else {
            // opcional: tratar erro de atualização
        }
    }).catch(error => {
        // opcional: log ou exibição de mensagem de erro
    });
};

    useEffect(()=>{
        if(props.coleta.idcoleta){
            getDetalhes() 
        }
    }, [props.coleta.idcoleta])


    const msgs = useRef(null);

    useEffect(() => {
        if (msgs.current) {
            if (props.coleta.monitorartoner === 't') {
                msgs.current.clear();
                msgs.current.show({ id: '1', sticky: true, severity: 'success', summary: 'Monitoramento de Toner', detail: 'Monitoramento de toner ', closable: false });
            }
        }
        
    }, [props.coleta.monitorartoner]); 



    const renderOpcaoMonitorament = (action = null) =>{
       
        if(props.coleta.monitorartoner ==='t'){
            if(props.coleta.alertaciano === 't' ||
                props.coleta.alertaamarelo === 't' ||
                props.coleta.alertamagenta === 't'  ||
                props.coleta.alertamagent === 't' ){
                return  'Individual'     
            }else{
                return 'Global'
            }
        }else{
            return 'Desligado'
        }

    }
   useEffect(()=>{
    setTipoMonitoramento(renderOpcaoMonitorament())
   }, [props.coleta.alertaciano, props.coleta.alertaamarelo, props.coleta.alertamagent,props.coleta.alertamagent ])


    const renderMensagemToner = () =>{
        if(props.coleta.monitorartoner ==='t'){
            if(props.coleta.alertaciano === 't' ||
                props.coleta.alertaamarelo === 't' ||
                props.coleta.alertamagenta === 't'  ||
                props.coleta.alertapreto === 't' ){
                return  <Message
                            severity="contrast"
                            content={
                                <div className="flex align-items-center gap-1 pl-2 pr-2">
                                <div style={{textAlign:'center'}}>
                                <i className={"pi pi-print text-4xl primary"} style={{ fontSize: '1.3rem', paddingLeft : '5px', paddingRight : '5px' }} /><br/>
                                <span style={{fontSize :'0.5rem'}}>Individual</span>
                                </div>
                                <div className='pl-2'>
                                    <span>Suprimento monitorado de forma <strong>INDIVIDUALMENTE</strong>, seguindo definições configuradas na licença de coleta.</span><br />
                                    <span style={{fontSize: '0.9rem', marginTop :'2px', paddingTop : '2px'}}>
                                        C: {props.coleta.nivelalertaciano+'%'} 
                                        M: {props.coleta.nivelalertaciano+'%'} 
                                        Y: {props.coleta.nivelalertaciano+'%'} 
                                        K: {props.coleta.nivelalertaciano+'%'} .
                                    </span>
                                    <br/>
                                </div>
                                
                                </div>
                            }
                            
                            /> 
            }else{
                return <Message
                            severity="contrast"
                            content={
                                <div className="flex align-items-center gap-1 pl-2 pr-2">
                                <div style={{textAlign:'center'}}>
                                <i className={"pi pi-globe text-4xl primary"} style={{ fontSize: '1.3rem', paddingLeft : '5px', paddingRight : '5px' }} /><br/>
                                <span style={{fontSize :'0.5rem'}}>Global</span>
                                </div>
                                <div className='pl-2'>
                                    <span>Suprimento monitorado de forma <strong>GLOBAL</strong>, seguindo definições configuradas na licença de coleta.</span><br />
                                    <span style={{fontSize: '0.9rem', marginTop :'2px', paddingTop : '2px'}}>
                                        C : {props.coleta.monitoramentociano+'%'} 
                                        M : {props.coleta.monitoramentomagenta+'%'} 
                                        Y : {props.coleta.monitoramentoamarelo+'%'} 
                                        K : {props.coleta.monitoramentopreto+'%'} .</span><br/>
                                </div>
                                
                                </div>
                            }
                            
                            /> 
            }
        }

        
    }
    return (
        <React.Fragment>
         
            <Sidebar 
                onHide={() => {
                    props.setColeta([])
                    setDetalhes({
                        placa : '', 
                        setor : '', 
                        serialalternativo : ''
                    })
                    
                }}
                header={customHeader} 
                visible={props.coleta.idcoleta} 
                style={{width:windowWidth < 768 ? '100%': '60%'}} 
                position="right" 
                className="custom-sidebar"
                {...props}
            >
            <Divider/> 
                <div className='pl-3 gap-2'>
                    <Tag severity="contrast"  value={'Chave :'   + props.coleta.chavedca}></Tag>  
                    <Tag severity="contrast" style={{marginLeft : '5px'}} value={'DCA :'   + props.coleta.iddca}></Tag> 
                </div>
                <div className="flex flex-wrap gap-0" >  
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm" style={{ width : '100%'}}>Sistema</span>
                            <TagStatusEquipamento    
                                ativo = {props.coleta.ativo}
                                dias = {props.coleta.dias}
                                equipamentonovo = {props.coleta.equipamentonovo}                        
                                status ={props.coleta.statussistema}/>
                            
                        </div>
                        <div className="col-12 md:col-3">
                            <span className="font-medium text-sm" style={{ width : '100%'}}>Copia</span>
                            <TagStatusEquipamento   
                                ativo = {props.coleta.ativo}
                                dias = {props.coleta.dias}
                                equipamentonovo = {props.coleta.equipamentonovo}                      
                                status ={props.coleta.statuscopiadora}/>
                        </div>
                        <div className="col-12 md:col-3">
                            <div className="font-medium text-sm" style={{ width : '100%'}}>Printer</div>
                            <TagStatusEquipamento 
                                dias = {props.coleta.dias}
                                ativo = {props.coleta.ativo}
                                equipamentonovo = {props.coleta.equipamentonovo}
                                status ={props.coleta.statusimpressora}/>
                        </div>
                        <div className="col-12 md:col-3">
                            <div className="font-medium text-sm" style={{ width : '100%'}}>Scanner</div>
                            <TagStatusEquipamento 
                                ativo = {props.coleta.ativo}
                                dias = {props.coleta.dias}
                                equipamentonovo = {props.coleta.equipamentonovo}
                                status ={props.coleta.statusscanner}/>
                        </div>                        

                    </div>                                 
                <TabView style={{marginTop : '20px'}} tabIndex={0}>
                   
                <TabPanel header={"Cadastro"} leftIcon="pi pi-pen-to-square text-2xl"  tabIndex={1}>
                  
                    <div className="flex flex-wrap gap-0">
                        
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual">Descoberta</label>
                        <InputText
                            name="numeroserie"
                            disabled
                            value={detalhes.datacadastro+' '+detalhes.horacadastro?.substr(0,8)}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual">Ativação</label>
                        <InputText
                            name="serialalternativo"
                            disabled
                            value={detalhes.dataativacao}
                            className="w-full mt-2"
                        />
                    </div>

                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual">Coleta</label>
                        <InputText
                            name="placa"
                            disabled
                            value={detalhes.datacoleta+' '+detalhes.horacoleta?.substr(0,8)}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual">Desativação</label>
                        <InputText
                            name="marca"
                            disabled
                            value={detalhes.datadesativacao}
                            className="w-full mt-2"
                        />
                    </div>
                    </div>

                    <div className="flex flex-wrap gap-0">
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual">Nº Série</label>
                        <InputText
                            name="numeroserie"
                            disabled
                            value={props.coleta.numeroserie}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual" style={{fontWeight : 'bold'}}>Nº Série alternativo</label>
                        <InputText
                            disabled={props.disableFuncions}
                            name="serialalternativo"
                            value={detalhes.serialalternativo}
                            onChange={(e)=>{
                                setDetalhes((prevData)=>({
                                    ...prevData, 
                                    serialalternativo : e.target.value
                                }))
                            }}
                            className="w-full mt-2"
                        />
                    </div>

                    <div className="col-12 md:col-1">
                        <label htmlFor="inscEstadual" style={{fontWeight : 'bold'}}>Nº PAT</label>
                        <InputText
                            name="placa"
                            disabled={props.disableFuncions}
                            onChange={(e)=>{
                                setDetalhes((prevData)=>({
                                    ...prevData, 
                                    placa : e.target.value
                                }))
                            }}
                            value={detalhes.placa}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-5">
                        <label htmlFor="inscEstadual">Marca</label>
                        <InputText
                            name="marca"
                            disabled
                            value={props.coleta.marca}
                            className="w-full mt-2"
                        />
                    </div>
                    </div>

                    <div className="flex flex-wrap gap-0">
                    <div className="col-12 md:col-6">
                        <label htmlFor="inscEstadual">Modelo</label>
                        <InputText
                            name="numeroserie"
                            disabled
                            value={props.coleta.modelo}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-4">
                        <label htmlFor="inscEstadual" style={{fontWeight : 'bold'}}>Setor (Syslocation)</label>
                        <InputText
                            disabled={props.disableFuncions}
                            name="setor"
                            onChange={(e)=>{
                                setDetalhes((prevData)=>({
                                    ...prevData, 
                                    setor : e.target.value
                                }))
                            }}
                            value={detalhes.setor}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-2">
                        <label htmlFor="inscEstadual" style={{fontWeight : 'bold'}}>R$ Valor</label>
                        <InputNumber 
                            disabled={props.disableFuncions}
                            name="valor"
                            onChange={(e)=>{
                                setDetalhes((prevData)=>({
                                    ...prevData, 
                                    valorfranquia : e.target.value
                                }))
                            }}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            value={detalhes.valorfranquia}
                            className="w-full mt-2"
                        />
                    </div>
                    </div>

                    <div className="flex flex-wrap gap-0">
                    <div className="col-12 md:col-2">
                        <label htmlFor="inscEstadual">Endereço IP</label>
                        <InputText
                            name="numeroserie"
                            disabled
                            value={props.coleta.enderecoip}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-2">
                        <label htmlFor="inscEstadual">MAC</label>
                        <InputText
                            name="setor"
                            disabled
                            value={detalhes.macaddress?.replace(/ /g, '-')}
                            className="w-full mt-2"
                        />
                    </div>
                    <div className="col-12 md:col-3">
                        <label htmlFor="inscEstadual">UPTime</label>
                        <InputText
                            name="setor"
                            disabled
                            value={detalhes.sysuptime}
                            className="w-full mt-2"
                        />
                    </div>

                    <div className="col-12 md:col-5">
                        <label htmlFor="inscEstadual">Painel</label>
                        <InputTextarea 
                            name="setor"
                            disabled
                            value={detalhes.mensagempainel}
                            rows={5} 
                            className="w-full mt-2"
                        />
                    </div>

                    </div>
                    

                    <div className="mt-4 flex justify-content-end mt-2">
                        <Button disabled={props.loading || props.disableFuncions} severity="secondary" className="mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                props.setColeta([])
                        }} />
                        <Button disabled={props.loading  || props.disableFuncions}  severity="primary" className="mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                                
                                confirmDialog({
                                message: 'Confirma a inclusão dessa nova empresa?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                    updateCadastroEquipamento()
                                } 
                            });
                        }} />
                    </div>


                    </TabPanel>
                    <TabPanel header="Medidores" leftIcon="pi pi-chart-line mr-2 text-2xl"  tabIndex={2}>
                    
                        <DataTable
                                className='text-sm'
                                paginator
                                size={'small'}
                                rows={20} // Número de itens por página
                                rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                                responsiveLayout="scroll"
                                value={contadores}>
                                    <Column
                                        field='name'
                                        header='Descrição Medidor'
                                        body={(row) => {
                                            return <span style={{ fontWeight: row.title === true ? 'bold' : 'normal', paddingLeft : row.padding, 
                                                fontSize : row.title === true ? '0.9rem' : '0.7rem'
                                            }}>{row.name}</span>;
                                        }}
                                    />

                                    <Column
                                        field='value'
                                        header='Valor do Medidor'
                                        body={(row) => {
                                            return <span style={{ fontWeight: row.title === true ? 'bold' : 'normal', 
                                                fontSize : row.title === true ? '0.9rem' : '0.7rem' }}>{row.value}</span>;
                                        }}
                                    />

                                
                        </DataTable>
                    </TabPanel>
                    
                    <TabPanel header="Suprimentos" leftIcon="pi pi-sliders-v mr-2 text-2xl" tabIndex={3}>
                    <span>Status monitoramento de suprimentos</span>
                    <SelectButton 
                    
                        disabled ={props.coleta.monitorartoner === 'f' || props.disabledNiveis || props.disableFuncions} value={tipoMonitoramento} 
                        style={{marginTop : '15px'}}  
                        onClick={(e)=>handleChange(e.target.innerText)}
                        options={options}/>

                    <div className="flex flex-wrap pb-2" style={{marginTop :'30px'}}>
                        <div className="col-12 md:col-3">
                            <TonerLevel 
                                nivel={detalhes.nivelciano} 
                                cor='ciano'
                                height='160px'
                                width='80px'
                                fontSize ='0.8rem'
                                sizeIcon ='2.5rem'
                                onClick = {
                                    () => {
                                        setOpenPrevisao({
                                            open : true, 
                                            cor : 'CIANO', 
                                            numeroserie : detalhes.numeroserie
                                        })
                                    }
                                }
                                numeroserie ={detalhes.numeroserieciano ? detalhes.numeroserieciano : '*Não disponível'}/>
                        </div>
                        <div className="col-12 md:col-3">
                            <TonerLevel 
                                nivel={detalhes.nivelmagenta} 
                                cor='magenta'
                                height='160px'
                                width='80px'
                                fontSize ='0.8rem'
                                sizeIcon ='2.5rem'
                                onClick = {
                                    () => {
                                        setOpenPrevisao({
                                            open : true, 
                                            cor : 'MAGENTA', 
                                            numeroserie : detalhes.numeroserie
                                        })
                                    }
                                }
                                numeroserie ={detalhes.numeroseriemagenta ? detalhes.numeroseriemagenta : '*Não disponível'}/>                                
                        </div>

                        <div className="col-12 md:col-3">
                            <TonerLevel 
                                nivel={detalhes.nivelamarelo} 
                                cor='amarelo'
                                height='160px'
                                width='80px'
                                fontSize ='0.8rem'
                                sizeIcon ='2.5rem'
                                onClick = {
                                    () => {
                                        setOpenPrevisao({
                                            open : true, 
                                            cor : 'AMARELO', 
                                            numeroserie : detalhes.numeroserie
                                        })
                                    }
                                }
                                numeroserie ={detalhes.numeroserieamarelo ? detalhes.numeroserieamarelo : '*Não disponível'}/>
                        </div>

                        <div className="col-12 md:col-2">
                            <TonerLevel 
                                nivel={detalhes.nivelpreto} 
                                cor='preto'
                                height='160px'
                                width='80px'
                                fontSize ='0.8rem'
                                sizeIcon ='2.5rem'
                                onClick = {
                                    () => {
                                        setOpenPrevisao({
                                            open : true, 
                                            cor : 'PRETO', 
                                            numeroserie : detalhes.numeroserie
                                        })
                                    }
                                }
                                numeroserie ={detalhes.numeroseriepreto ? detalhes.numeroseriepreto : '*Não disponível'}/>
              
                        </div>
                        {
                            renderMensagemToner()
                        }
                    </div>

                    <TabView style={{marginTop : '10px'}}>
                        
                        <TabPanel header="Estimativas" leftIcon="pi pi-calendar-clock mr-2 text-2xl" >
                            <div className="card flex flex-wrap align-items-start mt-1">
                            {
                                detalhes.previsaoToner ? detalhes.previsaoToner.map(function(previsao, i){
                                    let ativo = false;
                                    
                                    switch(previsao.cor){
                                        case 'CIANO':
                                            ativo = detalhes.nivelciano && detalhes.nivelciano >= 3;
                                        break;

                                        case 'MAGENTA':
                                            ativo = detalhes.nivelmagenta && detalhes.nivelmagenta >= 3;
                                        break;

                                        case 'AMARELO':
                                            ativo = detalhes.nivelamarelo && detalhes.nivelamarelo >= 3;
                                        break;

                                        case 'PRETO':
                                            ativo = detalhes.nivelpreto && detalhes.nivelpreto >= 3;
                                        break;

                                    }

                                    return ativo ? 
                                    <Message
                                        severity="contrast"
                                        content={
                                            <div className="flex align-items-center gap-1 pl-2 pr-2">
                                            <div style={{textAlign:'center'}}>
                                            <i className={previsao.metodo === 'regressao-linear' ? "pi pi-chart-scatter text-3xl primary" : "pi pi-chart-line text-3xl primary"} style={{ fontSize: '1.3rem', paddingLeft : '5px', paddingRight : '5px' }} /><br/>
                                            <span style={{fontSize :'0.5rem'}}>{previsao.metodo}</span>
                                            </div>
                                            <div className='pl-2'>

                                                <span><strong>Estimativa para o toner {previsao.cor}</strong></span><br />
                                                <span style={{fontSize: '0.9rem', marginTop :'2px', paddingTop : '2px'}}>O fim do toner está previsto para ocorrer em {(previsao.dias + previsao.dias2) / 2} dia(s), entre <strong>{previsao.data_prevista+' e '+(previsao.data_prevista2 ? previsao.data_prevista2 :previsao.data_prevista)} </strong>.</span><br/>
                                                <span style={{fontSize: '0.7rem'}}>Consumo médio {previsao.consumomedio ? previsao.consumomedio+'% de toner por dia' : (previsao.nivel / previsao.dias)+'% de toner por dia'}</span><br/>
                                                
                                            </div>
                                            
                                            </div>
                                    }
                                    
                                    /> : null 
                                }) : null
                            }
                            </div>
                        </TabPanel>

                    </TabView>
                    
                    </TabPanel>
                    
                    
                    <TabPanel header="Informações Gerais" leftIcon="pi pi-objects-column mr-2 text-2xl">
                    
                        <DataTable
                            className='text-sm'
                            paginator
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            value={detalhes.erros}>
                                <Column
                                    field='prtalertdescription'
                                    header='Descrição [RFC 1759]'
                                />

                                <Column
                                    field='dataalerta'
                                    header='Data'
                                />

                                <Column
                                    field='horaalerta'
                                    header='Hora'
                                />
                            
                        </DataTable>
                    
                   
                    </TabPanel>
                    <TabPanel header="Outras Informações" leftIcon="pi pi-clipboard mr-2 text-2xl">
                    <div className="flex flex-wrap gap-1" >  
                        {detalhes.versaofirmware  ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão Firmware</span>
                            <div className="text-md mt-2">{detalhes.versaofirmware ? detalhes.versaofirmware :'---'}</div>
                        </div> : null }

                        {detalhes.subfirmware ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão Subfirmware</span>
                            <div className="text-md mt-2">{detalhes.subfirmware ? detalhes.subfirmware :'---'}</div>
                        </div> : null }

                        {detalhes.firmwareps3 ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão Postscript</span>
                            <div className="text-md mt-2">{detalhes.firmwareps3 ?detalhes.firmwareps3 :'---'}</div>
                        </div> : null }

                        {detalhes.firmwarepcl5e ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão PCL5e</span>
                            <div className="text-md mt-2">{detalhes.firmwarepcl5e ? detalhes.firmwarepcl5e:'---'}</div>
                        </div> : null }

                        {detalhes.versaodofirmwareui ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão UI</span>
                            <div className="text-md mt-2">{detalhes.versaodofirmwareui ? detalhes.versaodofirmwareui :'---'}</div>
                        </div> : null }

                        {detalhes.versaoxoa ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão XOA</span>
                            <div className="text-md mt-2">{detalhes.versaoxoa ?detalhes.versaoxoa :'---'}</div>
                        </div> : null }

                        {detalhes.firmwarepdf ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão PDF</span>
                            <div className="text-md mt-2">{detalhes.firmwarepdf ?detalhes.firmwarepdf :'---'}</div>
                        </div> : null } 

                        {detalhes.versaobootrom ? <div className="col-12 md:col-6">
                            <span className="font-small text-sm">Versão Boot Rom</span>
                            <div className="text-md mt-2">{detalhes.versaobootrom ? detalhes.versaobootrom :'---'}</div>
                        </div> 
                        : 
                        null 
                        }
                    </div>
                    <div className="flex flex-wrap pb-2">
                    {detalhes.nivelcilindrociano ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelcilindrociano} 
                                cor='ciano'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Cilindro Ciano'
                                numeroserie ={detalhes.serialcilindrociano ? detalhes.serialcilindrociano : '*Não disponível'}/>
                        </div> 
                        : 
                        null 
                        }

                        {detalhes.nivelcilindromagenta ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelcilindromagenta} 
                                cor='magenta'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Cilindro Magenta'
                                numeroserie ={detalhes.serialcilindromagenta ? detalhes.serialcilindromagenta : '*Não disponível'}/>
                        </div> 
                        : 
                        null 
                        }

                        {detalhes.nivelcilindroamarelo ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelcilindroamarelo} 
                                cor='amarelo'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Cilindro Amarelo'
                                numeroserie ={detalhes.serialcilindroamarelo ? detalhes.serialcilindroamarelo : '*Não disponível'}/>
                        </div> : null}

                        {detalhes.nivelcilindropreto ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelcilindropreto} 
                                cor='preto'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Cilindro Preto'
                                numeroserie ={detalhes.serialcilindropreto ? detalhes.serialcilindropreto : '*Não disponível'}/>
                        </div> 
                        : 
                        null 
                        }

                        {detalhes.nivelfusor ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelfusor} 
                                cor='preto'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Unidade Fusão'
                                numeroserie ={detalhes.serialcilindropreto ? detalhes.serialcilindropreto : '*Não disponível'}/>
                        </div> 
                        : 
                        null 
                        }
                        {detalhes.nivellaser ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivellaser} 
                                cor='preto'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Unidade Laser'
                                />
                        </div> 
                        : 
                        null
                        }
                        {detalhes.nivelreservatoriotonerusado ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelreservatoriotonerusado} 
                                cor='preto'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Unidade Toner Usado'
                                />
                        </div> 
                        : 
                        null
                        }
                        {detalhes.nivelunidadetransferencia ? <div className="col-12 md:col-12">
                            <NivelGeral 
                                nivel={detalhes.nivelunidadetransferencia} 
                                cor='preto'
                                height='160px'
                                width='80px'
                                fontSize ='1rem'
                                label='Unidade Transferencia'
                                />
                        </div> 
                        : 
                        null 
                        }
                       
                       
                       
                    </div>
                    </TabPanel>
                </TabView>
                <ModalGraficoConsumo openPrevisao={openPrevisao} setOpenPrevisao={setOpenPrevisao}/>
                <ModalSliderNiveisToner 
                    showMessageToast ={props.showMessageToast} 
                    nivelAlertaIndividual ={nivelAlertaIndividual}  
                    setNivelAlertaIndividual ={setNivelAlertaIndividual} 
                    setColetasNiveis ={(data)=>{
                            props.setColetasNiveis(props.coleta.idcoleta, data)
                            setTipoMonitoramento('Individual')
                }}/>
                
            </Sidebar>
            
        </React.Fragment>
    );
}


